export interface RefillParams {
  availableColors: number;
  minColors: number;
  maxColors: number;
  minFill: number;
  maxFill: number;
}

export interface RefillMiddleware {
  processRefill(params: RefillParams): RefillParams;
}

export interface RefillParamModifierValue {
  offset: number;
  minValue?: number;
  maxValue?: number;
}

export interface RefillParamsModifier {
  maxColors?: RefillParamModifierValue;
  minColors?: RefillParamModifierValue;
  minFill?: RefillParamModifierValue;
  maxFill?: RefillParamModifierValue;
}

export function applyRefillParamsModifier(params: RefillParams, paramsModifier: RefillParamsModifier): RefillParams {
  Object.entries(paramsModifier).forEach(([key, value]) => {
    let newValue = params[key as keyof RefillParams];
    const mod = value as RefillParamModifierValue;

    newValue += mod.offset;
    if (mod.maxValue !== undefined) {
      newValue = Math.min(newValue, mod.maxValue);
    }
    if (mod.minValue !== undefined) {
      newValue = Math.max(newValue, mod.minValue);
    }

    params[key as keyof RefillParams] = newValue;
  });

  return params;
}

export class StaticModifierRefillMiddleware implements RefillMiddleware {
  constructor(private readonly paramsModifier: RefillParamsModifier) {}

  public processRefill(params: RefillParams): RefillParams {
    return applyRefillParamsModifier(params, this.paramsModifier);
  }
}
